module.exports = __webpack_public_path__ + "assets/HKNova-Thin.woff";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-Thin.woff
// module id = 149
// module chunks = 0